import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getNotifications } from '../../api';
import { NotificationsName } from '../name';

export const notificationsGetSlice = createGetAsyncSlice({
	name: NotificationsName,
	receive: true,
	request: false,
	requestHandler: getNotifications,
	retainDataOnRequest: true
});
